import { Meta, StoryObject } from '@benzinga/advanced-news-manager';
import { Impression, ImpressionBase } from './entities';
import { Term } from './entities';

export const isContentHasReachImpressionLimit = (articleMeta?: Meta): boolean => {
  return typeof articleMeta?.Reach?.RecirculationImpressionLimit !== 'undefined';
};

export const filterContentByEnabledReachImpression = (content: StoryObject[]): StoryObject[] => {
  return content?.filter(story => {
    return isContentHasReachImpressionLimit(story.meta);
  });
};

export const getContentLimitationToUpdate = (impressions: Impression[], contentLimitMap: Record<string, number>) => {
  const limitedContentToUpdate: Record<string, number> = {};

  impressions?.forEach(impression => {
    if (contentLimitMap[impression.content_id]) {
      if (Number(impression.limit) != Number(contentLimitMap[impression.content_id])) {
        limitedContentToUpdate[impression.content_id] = contentLimitMap[impression.content_id];
      }
    }
  });

  return limitedContentToUpdate;
};

export const getExpiredContentLimitations = (impressions: Impression[]): number[] => {
  const limitedContentExpiredIDs: number[] = [];

  impressions?.forEach(impression => {
    if (Number(impression.current_count) >= Number(impression.limit)) {
      limitedContentExpiredIDs.push(impression.content_id);
    }
  });

  return limitedContentExpiredIDs;
};

export const filterExpiredContentLimitation = (data: Impression[], stories: StoryObject[]): StoryObject[] => {
  const limitedContentExpiredIDs = getExpiredContentLimitations(data);
  if (limitedContentExpiredIDs?.length) {
    return stories.filter(story => !limitedContentExpiredIDs.includes(story.id));
  }

  return stories;
};

export const mapEnabledReachImpressionContent = (content: StoryObject[]): Record<string, number> => {
  const limitedContent = {};

  content?.forEach(story => {
    if (isContentHasReachImpressionLimit(story.meta)) {
      limitedContent[story.id] = story.meta?.Reach?.RecirculationImpressionLimit;
    }
  });

  return limitedContent;
};

export const handleNotFoundContentLimitations = (
  contentIds: number[],
  limitedContent: Record<number, number>,
): ImpressionBase[] => {
  const newImpressions: ImpressionBase[] = [];

  contentIds?.forEach(contentId => {
    newImpressions.push({
      content_id: contentId,
      current_count: 0,
      limit: limitedContent?.[contentId] || 0,
      limit_type: 'month',
    });
  });

  return newImpressions ?? [];
};

export const formatTermsSurrogateKeys = (term: Term): string => {
  if (!term) return '';

  return `taxonomy/term/${term.tid}`;
};

const REGISTERED_IMPRESSIONS_SLUG = 'registeredImpressions';
export const storeGlobalImpression = (value: string): void => {
  if (window[REGISTERED_IMPRESSIONS_SLUG]) {
    window[REGISTERED_IMPRESSIONS_SLUG].push(value);
  } else {
    window[REGISTERED_IMPRESSIONS_SLUG] = [value];
  }
};

export const isGlobalImpressionStored = (value: string): boolean => {
  return window[REGISTERED_IMPRESSIONS_SLUG]?.includes(value);
};

export const isFitFeedIndexPlacement = (feedIndex: number, initialIndex = 3, nthIndex = 5): boolean => {
  const placementIndex = feedIndex - initialIndex;

  return (placementIndex > 0 && placementIndex % nthIndex === 0) || feedIndex === initialIndex - 1;
};

export const getRandomContentIndex = (contentFeed: StoryObject[]): number => {
  return Math.floor(Math.random() * contentFeed?.length);
};
